import { render, staticRenderFns } from "./cert-example.vue?vue&type=template&id=3034ae06&scoped=true"
import script from "./cert-example.vue?vue&type=script&lang=ts"
export * from "./cert-example.vue?vue&type=script&lang=ts"
import style0 from "./cert-example.vue?vue&type=style&index=0&id=3034ae06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3034ae06",
  null
  
)

export default component.exports